<!--
  - Copyright (c) 2022.
  - Dev owner: Sedov A Sergey
  - Contact: sedov.sergey@isnlab.com
  -->

<template>
  <li class="nav-item">
    <router-link :class="['nav-link', hasSub ? 'submenu-toggle' : '', !opened ? 'collapsed' : '']" :to="route || '#'" :aria-expanded="opened ? 'true' : 'false'">
      <span class="nav-icon">
        <slot name="icon"></slot>
        <svg v-if="!hasIconSlot" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-app" viewBox="0 0 16 16">
          <path d="M11 2a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h6zM5 1a4 4 0 0 0-4 4v6a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4V5a4 4 0 0 0-4-4H5z"/>
        </svg>
      </span>
      <span class="nav-link-text">
        <slot name="text"></slot>
      </span>
      <span class="submenu-arrow" v-if="hasSub" @click.prevent="toggleSubmenu">
        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-chevron-down" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"></path>
        </svg>
      </span><!--//submenu-arrow-->
    </router-link>
    <div class="submenu collapse" :class="[opened ? 'show' : '']" v-if="hasSub">
      <ul class="submenu-list list-unstyled">
        <slot name="subitems"></slot>
        <SubItem v-for="(item, key) in subitems" :route="item.route || ''" :key="key" :text="item.text"></SubItem>
      </ul>
    </div>
  </li>
</template>

<script>
import {isset} from "@/inc/isset";
import SubItem from "@/components/menu/SubItem";

export default {
  name: 'NavItem',
  components: {SubItem},
  props : {
    route : Object,
    hasOpened : Boolean,
    // hasSub : { type: Boolean, default: false},
    subitems : {type: Array, default: () => []},
  },
  data () {
    return {
      id: null,
      opened : false
    }
  },
  mounted () {
    if (isset(()=>this.hasOpened))
    {
      this.opened = this.hasOpened
    }
  },
  methods : {
    toggleSubmenu : function (){
      console.log(this.opened)
      this.opened = !this.opened
    }
  },
  computed : {
    hasIconSlot () {
      return !!this.$slots['icon']
    },
    hasSubItemsSlot () {
      return !!this.$slots['subitems']
    },
    hasSub(){
      let This = this
      return isset(()=>This.subitems) && This.subitems.length > 0 || This.hasSubItemsSlot
    }
  }
}
</script>